import { render, staticRenderFns } from "./notification_error.vue?vue&type=template&id=00f25618&"
import script from "./notification_error.vue?vue&type=script&lang=ts&"
export * from "./notification_error.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports